import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ShieldAlert, XCircle, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

const REASON_LINKS = {
  WAIVER_INVALID: '/app/bookings',
  RESERVE_MISSING: '/app/documents',
  RESERVE_INVALID: '/app/documents',
};

const EligibilityBlocker = ({ reasons = [] }) => {
  const { t } = useTranslation();

  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="glass-card max-w-md w-full mx-4 p-6 rounded-xl border shadow-lg space-y-4">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center">
            <ShieldAlert className="h-5 w-5 text-red-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold">{t('funJumper.blocker.title')}</h2>
            <p className="text-sm text-muted-foreground">{t('funJumper.blocker.subtitle')}</p>
          </div>
        </div>

        <div className="space-y-2">
          {reasons.map((reason) => (
            <div key={reason.code} className="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 p-3">
              <XCircle className="h-4 w-4 text-red-500 mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-red-800">
                  {t(`funJumper.eligibility.reasons.${reason.code}`)}
                </p>
                <p className="text-xs text-red-600 mt-0.5">
                  {t(`funJumper.eligibility.fixActions.${reason.code}`)}
                </p>
              </div>
              {REASON_LINKS[reason.code] && (
                <Link to={REASON_LINKS[reason.code]}>
                  <Button variant="ghost" size="sm" className="h-7 px-2 text-red-700 hover:text-red-900">
                    <ExternalLink className="h-3.5 w-3.5" />
                  </Button>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EligibilityBlocker;
